import React from 'react';
import { connect } from 'react-redux';

import { hideModal } from '../../../services/modal/actions';

import ButtonComponent from '../../button/ButtonComponent';
import ErrorMessageComponent from '../../form-message/ErrorMessageComponent';
import AccountHelpComponent from '../accounthelp/AccountHelpComponent';

import './LoginErrorModal.scss';

/**
 * Modale d'erreur de connexion : affiche le message correspondant au code
 * renvoyé par le back (?error=X) au retour du SSO (Fnac ou Darty).
 * Le focus initial, le piège clavier et l'aria-label sont gérés par ModalRoot.
 */
class LoginErrorModal extends React.Component {
    handleClose = () => {
        const { hideModal, actionOnClose } = this.props;

        hideModal();
        if (actionOnClose) {
            actionOnClose();
        }
    };

    render() {
        const { i18n, errors, errorCode } = this.props;

        const message = (errors && errors[errorCode]) || (errors && errors.DEFAULT) || '';

        return (
            <div className="modal-login-error">
                <div className="container-header">{i18n.TITLE}</div>
                <div className="container-body">
                    <ErrorMessageComponent message={message} />
                    <AccountHelpComponent onLinkClick={this.handleClose} />
                    <div className="container-button">
                        <ButtonComponent
                            onClick={this.handleClose}
                            text={i18n.CLOSE_BUTTON}
                            color="main"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.LOGIN_ERROR_MODAL,
        errors: state.i18n.page.AUTHENTICATION.ERRORS
    };
};

const mapDispatchToProps = {
    hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginErrorModal);



// WEBPACK FOOTER //
// ./src/components/authentication/loginerror/LoginErrorModal.js